import React, { FC, useState } from 'react';
import { Button, Form, Input } from 'antd';
import { FormProps } from 'antd/lib/form';
import styled from 'styled-components';
import Papa from 'papaparse';
import { MediumText, SmallText } from '../../utils/typography';
import colors from '../../utils/colors';

type Props = FormProps & {
  onCreate: Function;
  closeModal: Function;
};

export const ImportUsersInOrganizationForm: FC<Props> = ({ id, onCreate, closeModal, ...formProps }) => {
  const [users, setUsers] = useState<{ email: string; name: string }[]>([]);
  const [error, setError] = useState('');
  const [file, setFile] = useState(null);
  const [form] = Form.useForm();

  const onFileChange = e => {
    const file = e.target.files[0];
    if (!file) return;

    Papa.parse(file, {
      header: true,
      delimiter: ',',
      newline: '\n',
      skipEmptyLines: true,
      complete: (results, file) => {
        setUsers(results.data);
        setError('');
        setFile(file);
      },
      error: (err, file) => {
        setUsers([]);
        setError(err.message);
        setFile(null);
      }
    });
  };

  return (
    <Form
      {...formProps}
      form={form}
      onFinish={async values => {
        const success = await onCreate(file);
        if (success) {
          form.resetFields();
          setFile(null);
          setUsers([]);
          closeModal();
        }
      }}
    >
      <Form.Item name="file" rules={[{ required: true }]}>
        <Input type="file" accept=".csv,.txt" onChange={onFileChange} />
      </Form.Item>
      {error && <ErrorMessage>{error}</ErrorMessage>}
      {users.length > 0 && (
        <>
          <UsersPreviewText>{'Users preview'}</UsersPreviewText>
          <UsersPreview>
            {users.map((user, index) => (
              <UserPreview key={index}>
                <EmailPreview>{user.email}</EmailPreview>
                <NamePreview>{user.name}</NamePreview>
              </UserPreview>
            ))}
          </UsersPreview>
        </>
      )}
      <Form.Item style={{ marginBottom: 0 }} {...{ wrapperCol: { offset: 20, span: 4 } }}>
        <Button type="primary" htmlType="submit">
          Import
        </Button>
      </Form.Item>
    </Form>
  );
};

const UsersPreview = styled.div`
  max-height: 300px;
  overflow: scroll;
`;

const UserPreview = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 6px;
`;

const UsersPreviewText = styled(MediumText)`
  display: block;
  margin-bottom: 16px;
`;

const EmailPreview = styled(SmallText)`
  width: 200px;
`;

const NamePreview = styled(SmallText)``;

const ErrorMessage = styled(MediumText)`
  color: ${colors.negative};
`;
